export function createCoordFromKey(key: string) {
  const [lat, lng] = key.split('-');

  return {
    lat: Number(lat),
    lng: Number(lng),
  };
}
